import React, {useEffect, useState} from 'react';
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  Button,
  IconButton,
  List,
  ListItem,
  Typography
} from "@material-tailwind/react";
import {getUserResourceList} from "../services/resource/resource";
import {ChevronDownIcon} from "@heroicons/react/16/solid";
import persianNumberFormat from "../helper/PersianNumberFormat";

const Sidebar = ({className, onClick, isOpen, setIsOpen}) => {
    const backgroundPhoto = '/assets/sidebarbg.jpg';
    const logo = '/assets/sideBar_logo_white.png';

    const [resourceList, setResourceList] = useState([])
    const [ungroupedResourceList, setUngroupedResourceList] = useState([])
    const [roleId, setRoleId] = useState(2)

    const [open, setOpen] = React.useState(-1);

    const handleOpen = (value) => {
        if (value === open) {
            setOpen(-1)
        } else {
            setOpen(value)
        }
    };

    useEffect(() => {
        async function getData() {
            const result = await getUserResourceList();
            if (result.status === 200) {
                const {resourceList, ungroupedResourceList, role_id} = result.data;
                setResourceList(resourceList);
                setUngroupedResourceList(ungroupedResourceList);
                setRoleId(role_id);
            }
        }

        getData()
    }, []);

    const isMobile = () => window.innerWidth <= 600;


    return (
        <div
            className={`${className} ${isOpen ? 'right-0 px-2' : '-right-full'} z-10 transition-all border-b border-gray-200 shadow-lg flex flex-col relative h-full`}
            style={{backgroundImage: `url(${backgroundPhoto})`, backgroundSize: 'cover', backgroundPosition: 'center'}}
        >
            <div className="absolute inset-0 bg-black opacity-80"></div>
            <div className="relative h-full flex flex-col">
                <div className="flex flex-row items-center border-b py-3">
                    <img src={logo} className="w-full" alt="Logo"/>
                </div>

                <div className="mb-2 flex items-center justify-between p-4">
                    <Typography variant="h5" color="white">
                        مباشر من
                    </Typography>
                    <IconButton
                        variant="text"
                        onClick={() => {
                            setIsOpen(false);
                        }}
                        color="white"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2}
                             stroke="white"
                             className="h-5 w-5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                    </IconButton>
                </div>

                {/* Add overflow-y-auto and h-full here */}
                <div className="overflow-y-auto flex-grow">
                    {ungroupedResourceList && ungroupedResourceList.length > 0 &&
                        <List className="text-white">
                            {ungroupedResourceList.map(({title, fa_title}) => (
                                <ListItem
                                    onClick={() => {
                                        onClick(`${title}`);
                                        if (isMobile()) {
                                            setIsOpen(false);
                                        }
                                    }}
                                    key={title}
                                >
                                    <Typography className="px-2 font-bold">{fa_title}</Typography>
                                </ListItem>
                            ))}
                        </List>
                    }

                    {resourceList && resourceList.length > 0 &&
                        <List className="text-white">
                            {resourceList.map(({group_fa_title, user_resource}, index) => (
                                    <Accordion
                                        open={open === index}
                                        icon={
                                            <ChevronDownIcon
                                                strokeWidth={2.5}
                                                className={`mx-auto h-4 w-4 transition-transform text-white ${open === index ? "rotate-180" : ""}`}
                                            />
                                        }
                                    >
                                        <ListItem className="p-0" selected={open === index}>
                                            <AccordionHeader onClick={() => handleOpen(index)} className="border-b-0 p-3">
                                                <Typography className=" text-start text-white px-2 font-bold">
                                                    {group_fa_title}
                                                </Typography>
                                            </AccordionHeader>
                                        </ListItem>
                                        <AccordionBody>
                                            <List className="text-white">
                                                {user_resource.map(({title, fa_title}) => (
                                                    <ListItem
                                                        className="flex flex-row"
                                                        onClick={() => {
                                                            onClick(`${title}`);
                                                            if (isMobile()) {
                                                                setIsOpen(false);
                                                            }
                                                        }}
                                                        key={title}
                                                    >
                                                        <Typography className="px-2 font-bold">{fa_title}</Typography>
                                                    </ListItem>
                                                ))}
                                                {/*</List>*/}
                                            </List>
                                        </AccordionBody>
                                    </Accordion>
                                )
                            )
                            }
                        </List>
                    }
                    <Button className="mt-3 ml-5 textRight" onClick={() => {
                        window.open("https://mymobasher.com", "_blank", "noreferrer");
                    }}>
                        <Typography className="font-bold" variant="small">
                            مشاهده سایت
                        </Typography>
                    </Button>

                    {(roleId !== 1 || roleId !== 5) &&
                        <Button className="mt-3 ml-5 textRight" onClick={() => {
                            window.location.href = `tel:+982191095190`;
                        }}>
                            <Typography className="font-bold" variant="small">
                                {persianNumberFormat(`تماس با پشتیبانی: 91095190-021`)}
                            </Typography>
                        </Button>
                    }

                </div>
            </div>
        </div>
    )
};

export default Sidebar;
